import React, { Component } from 'react';
import {Button, TextField} from '@betareader/design-system';
import { withTranslation } from 'react-i18next';

export class DisplayNameGetter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      displayName:  props.initialValue || ''
    };
  }

  handleDisplayNameChange = event => {
    this.setState({ displayName: event.target.value });
  }

  submit = () => {
    const { displayName } = this.state;
    if (this.props.onUpdate) {
      this.props.onUpdate({ displayName })
    }
  }

  isInvalid = () => {
    const { displayName } = this.state;
    return !displayName || displayName.trim().length === 0;
  }

  // render
  render() {
    const { t, updating } = this.props;
    const { displayName } = this.state;
    return (
      <div>
        <h2>{t('WhatsYourName')}</h2>
        <p>{t('OnYourProfile')}</p>
        <form onSubmit={event => {event.preventDefault(); if (!this.isInvalid()) this.submit();}}>
          <TextField id='profile-display-name' label={t('WhatsYourName')}
            placeholder={t('EnterYourName')} value={displayName}
            onChange={this.handleDisplayNameChange} />
          <Button type='submit' style={{marginTop: '1em'}}
            disabled={this.isInvalid() || updating} aria-busy={updating}>
            {t('Next')}
          </Button>
        </form>
      </div>
    );
  }
}

export default withTranslation()(DisplayNameGetter)
